import initStoreFinder from '//www.99bikes.co.nz/cdn/shop/t/830/assets/99-store-finder.js?v=158681923785501196941791325059';
import initDeposits from '//www.99bikes.co.nz/cdn/shop/t/830/assets/99-deposits.js?v=170440501146800692031791324103';
import initCustomBuyNow from '//www.99bikes.co.nz/cdn/shop/t/830/assets/99-custom-buy-now.js?v=47523340763132803961791324102';

document.addEventListener('DOMContentLoaded', () => {
  initStoreFinder();
  initDeposits();
  initCustomBuyNow();
});

//20260507 -PO, adding global functions for setting cart attributes/keeping track of cart updates
window.cartUpdates = window.cartUpdates || {};

//20260506 -PO, Check if an update has already been applied to this cart (including cart attribute updates, storefront cart mutation)
window.cartUpdates.hasCartUpdateBeenMade = function(update,value,token) {
  if (!token) return false;
  const recordedUpdates = JSON.parse(localStorage.getItem('recordedUpdates') || null) || {};
  return recordedUpdates?.[update]?.value === value && recordedUpdates?.[update]?.token === token;
}

//20260507 -PO, Clear recorded cart update, to avoid issues while awaiting an update call
window.cartUpdates.clearCartUpdateRecord = function(update) {
  const recordedUpdates = JSON.parse(localStorage.getItem('recordedUpdates') || null) || {};
  if(recordedUpdates?.[update]) delete recordedUpdates[update];
  localStorage.setItem('recordedUpdates',JSON.stringify(recordedUpdates));
}

//20260506 -PO, Record a cart update, to this cart token
window.cartUpdates.recordCartUpdate = function(update,value,token) {
  const recordedUpdates = JSON.parse(localStorage.getItem('recordedUpdates') || null) || {};
  recordedUpdates[update] = { value, token };
  localStorage.setItem('recordedUpdates',JSON.stringify(recordedUpdates));
}

window.cartUpdates.getCartToken = async function() {
  //get cookies using this approach https://stackoverflow.com/questions/10730362/get-cookie-by-name
  const value = `; ${document.cookie}`;
  const parts = value.split(`; cart=`);
  if (parts.length > 1) {
    return decodeURIComponent(parts.pop().split(';').shift())
  }

  //99B 20251001 -PO, change to get cart token from additional cart request instead of cookies (sometimes unreliable)
  console.warn("Failed to retrieve cart token from cookies, requesting from AJAX API instead.");
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error("AJAX API error retrieving cart token");
    }
    const data = await response.json();
    if (!data.token) {
      throw new Error("Error reading cart token");
    }
    return data.token;
  } catch(e) {
    console.error("Error retrieving cart token:",e);
  }  
}

// Utility function to update cart attributes directly via API
window.cartUpdates.updateCartAttribute = async function(key, value) {
  if (!window.theme.useCartAttributes) return;

  //20260506 -PO, change to check response and record if updates have been made (to reduce repeated requests)
  if (window.cartUpdates.hasCartUpdateBeenMade(key,value,await window.cartUpdates.getCartToken())) return;
  window.cartUpdates.clearCartUpdateRecord(key);

  const attributes = { [key]: value };
  const body = JSON.stringify({ attributes });
  const fetchConfig = FoxTheme?.utils?.fetchConfig ? FoxTheme.utils.fetchConfig() : {};
  const cartUpdateUrl = FoxTheme?.routes?.cart_update_url || '/cart/update.js';

  let token;
  try {
    const response = await fetch(cartUpdateUrl, Object.assign({}, fetchConfig, { body }));
    if (!response.ok) throw new Error(`Response not ok. Status code: ${response.status}.`);
    const data = await response.json();
    if (data?.attributes?.[key] !== value) {
      throw new Error(`Returned data does not have the correct attribute, instead displays "${data?.attributes?.[key]}". Data: ${JSON.stringify(data || null)}`);
    };
    token = data?.token;
  } catch(e) {
    console.error(`Failed to update cart attribute key: "${key}" to value: "${value}":`,e);
    return;
  }

  if (!token) {
    console.error(`Failed to record cart attribute update of key: "${key}" to value: "${value}", as no cart token received.`);
    return;
  }
  window.cartUpdates.recordCartUpdate(key,value,token);
}

//99B 20251016 -PO adding global Algolia tracking functions (to be used collections, search and pdp)
window.AlgoliaTracking = window.AlgoliaTracking || {};

//99B 20251103 -PO change to local storage approach (functions below currently not used)
window.AlgoliaTracking.trackSearchAttribution = async function (query_id, variant_id, product_id) {
  const clickData = {
    eventName: 'Product Added To Cart',
    index: 'shopify_products', 
    queryID: query_id,
    objectIDs: [variant_id],
    productId: product_id,
  };

  try {
      const localStorageKey = 'algolia_analytics_clicked_objects'; // Key

      // Get any data previously stored
      const previousClickItemsString =
        localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      // Add the current products data to local storage
      previousClickItems.push(clickData);
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems));
  } catch (error) {
    console.error(error);
  }
}